import types from '../types/summary'
import calendarTypes from '../types/calendar'
import startTypes from '../types/start'
import addressTypes from '../types/address'
import cardTypes from '../types/paymentMethod'
import {Map, List} from 'immutable'
import moment from '../../../common/moment'
import orchestratorTypes from '../types/orchestrator'

const initialRoot = Map({
  address: 0,
  addresses: List(),
  dateStart: null,
  dateEnd: null,
  timeslotStart: 0,
  timeslotEnd: 0,
  timeslotsStart: List(),
  timeslotsEnd: List(),
  card: 0,
  cards: List(),
  rentPrice: 0,
  deliveryCost: 0,
  pickupCost: 0,
  comment: '',
  isConfirming: false,
  requireCardForDeposit: true,
  isFetchingConfigKeys: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case startTypes.CREATE_SELF_RENT_SUCCESS: {
      const rent = action.payload.rent
      return state.merge({
        address: rent.Address ? rent.Address.ID : 0,
        dateStart: moment.utc(rent.Delivery.Reserve.Date),
        dateEnd: moment.utc(rent.Pickup.Reserve.Date),
        timeslotStart: rent.Delivery.Reserve.TimeSlot.ID,
        timeslotEnd: rent.Pickup.Reserve.TimeSlot.ID,
        card: rent.Card.ID,
        comment: rent.Comments,
        deliveryCost: action.payload.deliveryCost,
        pickupCost: action.payload.pickupCost,
      })
    }
    case startTypes.CREATE_RETURN_TRANSACTION_SUCCESS: {
      const transaction = action.payload.transaction
      return state.merge({
        address: transaction.ClientAddress ? transaction.ClientAddress.ID : 0,
        dateStart: moment.utc(transaction.Reserve.Date),
        dateEnd: null,
        timeslotStart: transaction.Reserve.TimeSlot.ID,
        timeslotEnd: 0,
        card: transaction.Card.ID,
        comment: transaction.Comments,
        deliveryCost: action.payload.deliveryCost,
      })
    }
    case calendarTypes.SELECT_DATES:
      return state.merge({
        dateStart: action.payload.dateStart,
        dateEnd: action.payload.dateEnd,
        timeslotStart: 0,
        timeslotEnd: 0,
      })
    case calendarTypes.SELECT_TIMESLOT: {
      if (action.payload.type === 'start') {
        return state.merge({
          timeslotStart: action.payload.timeslot,
          timeslotEnd: 0,
        })
      } else {
        return state.set('timeslotEnd', action.payload.timeslot)
      }
    }
    case calendarTypes.GET_TIMESLOTS_SUCCESS: {
      const type = action.payload.type === 'start' ? 'timeslotsStart' : 'timeslotsEnd'
      return state.merge({
        [type]: List(action.payload.timeslots),
      })
    }
    case calendarTypes.MODIFY_RENT_SUCCESS:
      return state.merge({
        rentPrice: action.payload.rent.Price,
      })
    case addressTypes.FETCH_SUCCESS:
      return state.merge({
        isFetchingAddresses: false,
        addresses: List(action.payload.addresses),
        error: '',
      })
    case addressTypes.SET_SELECTED:
      return state.set('address', action.payload.selected)
    case cardTypes.FETCH_SUCCESS:
      return state.set('cards', List(action.payload.cards))
    case cardTypes.SET_SELECTED:
      return state.set('card', action.payload.selected)
    case types.FETCH_RENT_COST_SUCCESS:
      return state.merge({
        deliveryCost: action.payload.deliveryCost,
        pickupCost: action.payload.pickupCost,
      })
    case types.SELECT_CARD:
      return state.set('card', action.payload.card)
    case types.SET_COMMENT:
      return state.set('comment', action.payload.value)
    case startTypes.MODIFY_AND_CONFIRM_RETURN:
    case startTypes.MODIFY_AND_CONFIRM_RENT:
      return state.merge({
        isConfirming: true,
        error: '',
      })
    case startTypes.MODIFY_AND_CONFIRM_RETURN_SUCCESS:
    case startTypes.MODIFY_AND_CONFIRM_RENT_SUCCESS:
      return state.merge({
        isConfirming: false,
        error: '',
      })
    case startTypes.MODIFY_AND_CONFIRM_RETURN_FAIL:
    case startTypes.MODIFY_AND_CONFIRM_RENT_FAIL:
      return state.merge({
        isConfirming: false,
        error: action.payload.error,
      })
    case types.GET_CONFIG_KEY:
      return state.merge({
        isFetchingConfigKeys: true,
        error: '',
      })
    case types.GET_CONFIG_KEY_SUCCESS:
      return state.merge({
        isFetchingConfigKeys: false,
        requireCardForDeposit: action.payload.requireCardForDeposit,
        error: '',
      })
    case types.GET_CONFIG_KEY_FAIL:
      return state.merge({
        isFetchingConfigKeys: false,
        error: action.payload.error,
      })
    case orchestratorTypes.START:
      return initialRoot
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/remove/reducers/summary.js